var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../I18N";









const Switcher = ({
  onChange,
  value,
  prefix,
  leftLabel = /*#__PURE__*/_jsx(Translate, { translationKey: "Filters AND operator" }, void 0, "AND"),
  rightLabel = /*#__PURE__*/_jsx(Translate, { translationKey: "Filters OR operator" }, void 0, "OR")
}) => {
  const onChangeHandler = (e) => {
    onChange(e.target.checked);
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "switcher-wrapper" }, void 0, /*#__PURE__*/
    _jsx("span", { className: value ? 'is-active' : '' }, void 0, leftLabel), /*#__PURE__*/
    _jsx("input", {
      id: `${prefix}switcher`,
      type: "checkbox",
      checked: value || false,
      onChange: onChangeHandler }
    ), /*#__PURE__*/
    _jsx("label", { htmlFor: `${prefix}switcher`, className: "switcher" }), /*#__PURE__*/
    _jsx("span", { className: value ? '' : 'is-active' }, void 0, rightLabel)
    ));

};

export { Switcher };